'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondAfter.js
// module id = 374
// module chunks = 1